import _ from 'lodash';
import moment from 'moment';
import commonConfig from '../components/commonConfig.json';

let customTabView = commonConfig.customTabView;
let envs = commonConfig.envs;
let datePickerConfigs = commonConfig.datePickerProps;
let dropdownConfigs = commonConfig.dropdownProps;
export const compViewskeyMapper = (input, inputType, outputType) => {
    let output = "";
    for (const key in customTabView) {
        if (customTabView[key][inputType] === input) {
            output = customTabView[key][outputType];
            break;
        }
    }

    return output;
}

export const structureIndexData = (indexType, data, viewTypes) => {
    let dataList = {};

    if (indexType === "Hotels") {
        for (const viewType of viewTypes) {
            if (viewType === "Daily") {
                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = data.reduce((accum, curr, index) => {
                    accum.push({
                        index: ++index,
                        id: curr.id,
                        code: curr.code,
                        codeEnv: curr.env === envs.MARRIOTT ? curr.code : curr.name,
                        label: curr.label,
                        name: curr.name,
                        entityId: curr.entityId,
                        projectId: curr.projectId,
                        status: curr.status,
                        env: curr.env,
                        goLiveDate: curr.goLiveDate,
                        sigGoLiveDate: curr.sigGoLiveDate,
                        signType: curr.signType,
                        envlopeTriggerType: curr.envlopeTriggerType,
                        timeZone: curr.timeZone,
                        pms: curr.pms,
                        customViewTypes: curr.customViewTypes,
                    });
                    return accum
                }, [])
            } else {
                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = data.filter(hotel => {
                    if (hotel.customViewTypes.length !== 0) {
                        return hotel.customViewTypes.map(type => type.envlopeTriggerScheduleType === viewType)
                    }
                }).reduce((accum, curr, index) => {
                    let filteredCustomView = curr.customViewTypes.filter(f => f.envlopeTriggerScheduleType === viewType);
                    accum.push({
                        index: ++index,
                        id: curr.id,
                        code: curr.code,
                        codeEnv: curr.env === envs.MARRIOTT ? curr.code : curr.name,
                        label: curr.label,
                        name: curr.name,
                        entityId: curr.entityId,
                        projectId: curr.projectId,
                        status: curr.status,
                        env: curr.env,
                        goLiveDate: curr.goLiveDate,
                        sigGoLiveDate: curr.sigGoLiveDate,
                        signType: curr.signType,
                        envlopeTriggerType: curr.envlopeTriggerType,
                        timeZone: curr.timeZone,
                        pms: curr.pms,
                        customViewTypes: filteredCustomView,
                    });
                    return accum;
                }, []);
            }
        }
    } else if (indexType === "Grouping") {
        for (const viewType of viewTypes) {
            if (data.comparingDataType === "Hotels") {
                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = data.groupedData.map(group => {
                    let allmappedList = [];
                    let allowedmappedListCount = 0;
                    if (group.genericHotelList.length !== 0) {
                        group.genericHotelList.forEach((element) => {
                            if (_.some(data.comparingData[compViewskeyMapper(viewType, "VALUE", "KEY")], d=> d.id === element && d.env === "Generic") === true) {
                                allmappedList.push({
                                    env: "Generic",
                                    id: element,
                                    isDisable: false
                                });
                                allowedmappedListCount++;
                            } else {
                                allmappedList.push({
                                    env: "Generic",
                                    id: element,
                                    isDisable: true
                                });
                            }
                        });
                    }
                    if (group.marriottHotelList.length !== 0) {
                        group.marriottHotelList.forEach((element) => {
                            if (_.some(data.comparingData[compViewskeyMapper(viewType, "VALUE", "KEY")], d=> d.id === element && d.env === "Marriott") === true) {
                                allmappedList.push({
                                    env: "Marriott",
                                    id: element,
                                    isDisable: false
                                });
                                allowedmappedListCount++;
                            } else {
                                allmappedList.push({
                                    env: "Marriott",
                                    id: element,
                                    isDisable: true
                                });
                            }
                        });
                    }
                    // if (allowedmappedListCount !== 0) {
                    return ({
                        userName: data.user,
                        userGroupId: group.userGroupId,
                        groupId: group.groupId,
                        groupName: group.groupName,
                        projectId: group.projectId,
                        entityId: group.entityId,
                        mappedList: allmappedList,
                        mappedIndexValueType: data.comparingDataType,
                        isDisable: (allowedmappedListCount !== 0 ? false : true)
                    });
                    // }
                }).filter(e => e !== undefined);
            }

        }
    } else if (indexType === "DependingDate") {
        for (const viewType of viewTypes) {
            if (viewType === "Daily") {
                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = data.dependentIndexValue.reduce((accum, curr, index) => {
                    accum.push({
                        index: ++index,
                        id: curr.id,
                        codeEnv: curr.codeEnv,
                        env: curr.env,
                        schedule: [],
                        startDate: moment(curr.goLiveDate, "DD/MM/YYYY").format("MM-DD-YYYY")
                    })
                    return accum
                }, [])
            } else {
                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = data.dependentIndexValue.reduce((accum, curr, index) => {
                    let shc = curr.customViewTypes.map(c => c.envlopeTriggerSchedule);
                    accum.push({
                        index: ++index,
                        id: curr.id,
                        codeEnv: curr.codeEnv,
                        env: curr.env,
                        schedule: shc,
                        startDate: moment(curr.goLiveDate, "DD/MM/YYYY").format("MM-DD-YYYY")
                    })
                    return accum
                }, [])
            }
        }
    } else if (indexType === "DependingText") {
        for (const viewType of viewTypes) {
            //sort the remaining cat
            //add additional data {data:include exclude val,type:include/exclude}
            //check All needed and set the value, mapped list,additional data {data:include exclude val,type:include/exclude}
            //add additional data {data:include exclude val,type:include/exclude} for no val
            ////prepend All, append noval
            if (viewType === "Daily") {
                let noVal = [];
                let noValIndex = [];
                let allVal = [];
                let secTrigVal = [];
                let secTrigValIndex = [];
                let validList = [];

                let copycurrentIndxValue = data.currentIndxValue.map(element => {
                    if (element.value === 'noVal') { //seperate the noval
                        noValIndex.push(element.id);
                    } else if (data.currentSolSecTriggerData !== undefined && (
                        (data.currentSolSecTriggerData.find(c =>    //if current index is of sec.trigger index, current index val contains in sec.trigger values
                            c.envlopeTriggerIndex === data.currentIndxname && c.envlopeTriggerIndexValue.includes(element.value)) !== undefined
                        ) ||
                        // (data.currentSolSecTriggerData.find(c => //if dependent index of current is of sec.trigger index,mapped dependent index val of current index contains in sec.trigger values
                        //     c.envlopeTriggerIndex === data.dependentIndexName &&
                        //     element.mappedList.find(lst =>
                        //         (lst[data.dependentIndexName] !== undefined &&
                        //             c.envlopeTriggerIndexValue.find(eIndV => {
                        //                 let fIndx = lst[data.dependentIndexName].findIndex(m => m.mappedVal === eIndV);
                        //                 return fIndx !== -1
                        //             }) !== undefined) //<-change required
                        //     ) !== undefined
                        // ) !== undefined) ||
                        (data.currentSolSecTriggerData.find(c =>
                            element.mappedList.find(lst => (
                                lst[c.envlopeTriggerIndex] !== undefined &&
                                c.envlopeTriggerIndexValue.find(envIndxVal => lst[c.envlopeTriggerIndex].findIndex(ele => ele.mappedVal.includes(envIndxVal)) > -1) !== undefined) //<-change required
                            ) !== undefined
                        ) !== undefined))
                    ) { // remove secondary trigger category from list
                        secTrigValIndex.push(element.id);
                    } else {
                        element['additionalData'] = { val: [element.value], visibleVal: [element.value], type: 'include' }
                    }

                    if (data.mode === dropdownConfigs.mode.MULTIPLE) {
                        element['label'] = element.value;
                    }

                    return element;
                });

                if (noValIndex.length !== 0) { //remove noval option from list
                    noVal = copycurrentIndxValue.splice(_.findIndex(copycurrentIndxValue, function (o) { return o.id === noValIndex[0] }), 1);
                }
                if (secTrigValIndex.length !== 0) { //remove sec trigger val option(s) from list
                    for (const id of secTrigValIndex) {
                        secTrigVal = secTrigVal.concat(copycurrentIndxValue.splice(_.findIndex(copycurrentIndxValue, function (o) { return o.id === id }), 1))
                    }
                }

                //sort and and index of sorted order
                validList = _.sortBy(copycurrentIndxValue, (o) => o.value)
                for (let i = 0; i < validList.length; i++) {
                    validList[i].index = i+1;
                }

                if (data.mode === dropdownConfigs.mode.SINGLE) {
                    if (noVal.length !== 0) {
                        noVal[0] = {
                            index: validList.length + 1,
                            id: noVal[0].id,
                            value: data.currentIndxname === 'Report Category' ? 'Reports without category' : 'Without' + data.currentIndxname,
                            mappedList: noVal[0].mappedList,
                            additionalData: validList.length > 0 ?
                                (secTrigVal.length > 0 ? { val: _.uniq(secTrigVal.concat(validList).map(s => s.value)), visibleVal: ['noVal'], type: 'exclude' } : { val: _.uniq(validList.map(s => s.value)), visibleVal: ['noVal'], type: 'exclude' }) :
                                (secTrigVal.length > 0 ? { val: _.uniq(secTrigVal.map(s => s.value)), visibleVal: ['noVal'], type: 'exclude' } : {})
                        }
                        validList.push(noVal[0]);
                    }
                    if (validList.length > 1) {
                        allVal.push({
                            index: 0,
                            id: 0,
                            value: 'All',
                            mappedList: data.dependentIndexValueType === 'Hotels' ? _.uniqWith(_.flatten((validList.concat(noVal)).map(s => s.mappedList)), _.isEqual) : _.uniqWith(_.flatten((validList.concat(noVal)).map(s => s.mappedList)), _.isEqual),
                            additionalData: secTrigVal.length !== 0 ? { val: _.uniq(secTrigVal.map(s => s.value)), visibleVal: _.uniq(secTrigVal.map(s => s.value)), type: 'exclude' } : {}
                        });
                        validList.unshift(allVal[0]);
                    }
                } else if (data.mode === dropdownConfigs.mode.MULTIPLE) {
                    if (noVal.length !== 0) {
                        noVal[0] = {
                            index: validList.length + 1,
                            id: noVal[0].id,
                            value: data.currentIndxname === 'Report Category' ? 'Reports without category' : 'Without' + data.currentIndxname,
                            label: data.currentIndxname === 'Report Category' ? 'Reports without category' : 'Without' + data.currentIndxname,
                            mappedList: noVal[0].mappedList,
                            additionalData: { val: ['noVal'], visibleVal: ['noVal'], type: 'include' }
                                    
                        }
                        validList.push(noVal[0]);
                    }
                }

                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = validList;

            } else { //other view types
                let allVal = [];
                let validList = [];

                let copycurrentIndxValue = data.currentIndxValue.filter(element => {
                    return (
                        data.currentSolSecTriggerData !== undefined &&
                        (
                            data.currentSolSecTriggerData.find(
                                c => c.envlopeTriggerIndex === data.currentIndxname &&
                                    c.envlopeTriggerScheduleType === viewType &&
                                    c.envlopeTriggerIndexValue.includes(element.value)
                            ) !== undefined // filter secondary trigger category from list
                            ||
                            (
                                data.currentSolSecTriggerData.find(c =>
                                    // c.envlopeTriggerIndex === data.dependentIndexName &&
                                    c.envlopeTriggerScheduleType === viewType &&
                                    element.mappedList.find(lst =>
                                        lst[c.envlopeTriggerIndex] !== undefined &&
                                        c.envlopeTriggerIndexValue.find(envIndxVal => 
                                            lst[c.envlopeTriggerIndex].findIndex(ele => ele.mappedVal.includes(envIndxVal)) > -1
                                        ) !== undefined
                                    // (lst.value !== undefined &&
                                    //     c.envlopeTriggerIndexValue.includes(lst.value))
                                    ) !== undefined
                                ) !== undefined
                            )
                        )
                    )
                }).map(c => {
                    c['additionalData'] = { val: [c.value], visibleVal: [c.value], type: 'include' };
                    if (data.mode === dropdownConfigs.mode.MULTIPLE) {
                        c['label'] = c.value;
                    }
                    return c;
                });

                //sort and and index of sorted order
                validList = _.sortBy(copycurrentIndxValue, (o) => o.value)
                for (let i = 0; i < validList.length; i++) {
                    validList[i].index = i+1;
                }

                if (data.mode === dropdownConfigs.mode.SINGLE) {
                    if (validList.length > 1) {
                        allVal.push({
                            index: 0,
                            id: 0,
                            value: 'All',
                            mappedList: data.dependentIndexValueType === 'Hotels' ? _.uniqWith(_.flatten((validList).map(s => s.mappedList)), _.isEqual) : _.uniqWith(_.flatten((validList).map(s => s.mappedList)), _.isEqual),
                            additionalData: { val: _.uniq(validList.map(s => s.value)), visibleVal: _.uniq(validList.map(s => s.value)), type: 'include' }
                        });
                        validList.unshift(allVal[0]);
                    }
                }


                dataList[compViewskeyMapper(viewType, "VALUE", "KEY")] = validList;

                //filter by dependentIndexValue, filter secondary signature by dependent index
                // {
                //     index,
                //     value,
                //     label,
                //     mappedList,
                //     additionalData:val, visibleVal, type
                // }
            }
        }
        // }
    }
    return dataList;
}
// "Hotels","local",currentSol[complianceMainTabActive].projData.hotels

export const recursiveSearch = (array, value) => {
    function find(object) {
        return Object
            .values(object)
            .some(v => v === value || v && typeof v === 'object' && find(v));
    }

    return array.filter(find);
}

export const processDateConfigs = (resultType, viewType, indxValType, schedule, mode, format, CDate) => {
    let result = {
        selectedRange: [],
        disableRange: { type: 'min_max', val: [] },
        modeExtensions: []
    }
    let validDates = [];
    let currentDate = (CDate !== undefined ? CDate : (indxValType === 'Date' ? [moment().subtract(1, "days").format(format)] : [moment().format(format)]));
    let from = currentDate[0];
    let to = currentDate[currentDate.length - 1];
    let dt = from;
    while (moment(dt, format).isBefore(moment(to, format)) === true || moment(dt, format).isSame(moment(to, format)) === true) {
        // let temValidDates = getViewBasedDateRange(viewType, schedule, currentDate, format)
        validDates = _.concat(validDates, getViewBasedDateRange(viewType, schedule, dt, format));
        dt = moment(dt, format).add(1, "day").format(format);
    }
    validDates = _.flatten(validDates);
    let uniqueValidDates = getUnique(validDates, 'date', format).sort((a, b) => moment(a, format).diff(moment(b, format)))

    if (resultType === 'selectedRange') {
        if (viewType === undefined || viewType === compViewskeyMapper("Daily", "VALUE", "KEY")) { //complianceMainTabActive undefined when its not compliance
            return result.selectedRange =
                (mode === undefined ? uniqueValidDates : //mode === undefined processing not related to datepicker default date selection
                    (mode === datePickerConfigs.mode.RANGE ?
                        [moment(uniqueValidDates[uniqueValidDates.length - 1], format).startOf('month').format(format), uniqueValidDates[uniqueValidDates.length - 1]] :
                        uniqueValidDates[uniqueValidDates.length - 1]
                    )
                )
        } else if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
            return result.selectedRange =
                (mode === undefined ? uniqueValidDates : //mode === undefined processing not related to datepicker default date selection
                    (mode === datePickerConfigs.mode.RANGE ?
                        [uniqueValidDates[0], uniqueValidDates[uniqueValidDates.length - 1]] :
                        uniqueValidDates[uniqueValidDates.length - 1]
                    )
                )
        }

    } else if (resultType === 'disableRange') {
        if (viewType === undefined || viewType === compViewskeyMapper("Daily", "VALUE", "KEY")) { //complianceMainTabActive undefined when its not compliance
            return result.disableRange = { type: 'min_max', val: currentDate.length > 1 ? [uniqueValidDates[0], uniqueValidDates[uniqueValidDates.length - 1]] : [uniqueValidDates[uniqueValidDates.length - 1]] };
        } else if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
            return result.disableRange = { type: 'adhoc', val: uniqueValidDates };
        }

    } else if (resultType === 'modeExtensions') {
        if (viewType === undefined || viewType === compViewskeyMapper("Daily", "VALUE", "KEY")) { //complianceMainTabActive undefined when its not compliance
            return result.modeExtensions = (mode !== undefined && mode === datePickerConfigs.mode.RANGE ? [
                datePickerConfigs.modeExtension.BUSINESS_DATE,
                datePickerConfigs.modeExtension.LAST_SEVEN_DAYS,
                datePickerConfigs.modeExtension.LAST_THIRTY_DAYS,
                datePickerConfigs.modeExtension.THIS_MONTH,
                datePickerConfigs.modeExtension.LAST_MONTH,
                datePickerConfigs.modeExtension.LAST_TWO_MONTHS,
                datePickerConfigs.modeExtension.CUSTOM_RANGE
            ] : []);
        } else if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
            return result.modeExtensions = (mode !== undefined && mode === datePickerConfigs.mode.RANGE ?
                (moment(to, format).startOf("month").isBefore(moment(uniqueValidDates[uniqueValidDates.length - 1], format)) || moment(to, format).startOf("month").isSame(moment(uniqueValidDates[uniqueValidDates.length - 1], format)) ? [ // if in current month - include this month else not
                    datePickerConfigs.modeExtension.THIS_MONTH,
                    datePickerConfigs.modeExtension.LAST_MONTH,
                    datePickerConfigs.modeExtension.LAST_TWO_MONTHS,
                    datePickerConfigs.modeExtension.CUSTOM_RANGE
                ] : [
                    datePickerConfigs.modeExtension.LAST_MONTH,
                    datePickerConfigs.modeExtension.LAST_TWO_MONTHS,
                    datePickerConfigs.modeExtension.CUSTOM_RANGE
                ])
                // [
                //     datePickerConfigs.modeExtension.LAST_MONTH,
                //     datePickerConfigs.modeExtension.LAST_TWO_MONTHS,
                //     datePickerConfigs.modeExtension.CUSTOM_RANGE]
                : []);
        }
    }
}

export const getUniqueTriggerSchedules = (configs, configType) => {

    if (configType === "schedule") {
        let uniqueTriggerSchedules = getUnique(configs, '', '');
        return uniqueTriggerSchedules;
    } else if (configType === "hotelData") {
        let cusViewTypes = [];
        for (const hotel of configs) {
            cusViewTypes = cusViewTypes.concat(hotel.customViewTypes);
        }
        let combined = cusViewTypes.map((v) => v.envlopeTriggerScheduleType + "," + v.envlopeTriggerSchedule)
        let uniqueTriggerSchedules = getUnique(combined, '', '');
        return uniqueTriggerSchedules.map((u) => u.split(",")); //eg: ["Monthly","last_day"]
    }
};

export const getUnique = (arr, type, format) => {
    if (type === "date") {
        let uniqueDates = arr.filter(
            (date, i, self) =>
                self.findIndex((d) => {
                    return (
                        moment(d, format).isSame(moment(date, format)) === true
                    );
                }) === i
        );
        return uniqueDates;
    } else {
        let uniqueList = arr.filter((value, index, self) => self.indexOf(value) === index);
        return uniqueList;
    }
}
export const getViewBasedDateRange = (viewType, schedule, currentBDate, format) => {
    let tempres = [];
    if (schedule.length === 0) {
        tempres.push(currentBDate);
    } else {
        let configDList = getConfigDate(viewType, schedule, currentBDate, format);
        for (const configD of configDList) {
            if (moment(configD, format).isAfter(moment(currentBDate, format)) === true) {
                tempres.push(false);
            } else {
                tempres.push(configD);
            }
        }
        // for (const sch of schedule) {
        //     let comparisionDate = moment().format(format);
        //     if (viewType === compViewskeyMapper("Daily", "VALUE", "KEY")) {
        //         comparisionDate = currentBDate;
        //     } else if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
        //         if (sch === "lastday") {
        //             comparisionDate = moment(currentBDate, format).endOf("month").format(format);
        //         } else {
        //             comparisionDate = moment(currentBDate, format).set("date", sch).format(format);
        //         }
        //     }

        //     if (moment(comparisionDate, format).isAfter(moment(currentBDate, format)) === true) {
        //         tempres.push(false);
        //     } else {
        //         tempres.push(comparisionDate);
        //     }
        // }
    }
    if (tempres.find((r) => r === false) !== undefined) {
        //if atleast one not in the range set the previous range
        let prev = moment();
        if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
            prev = moment(currentBDate, format)
                .subtract(1, "month")
                .endOf("month").format(format);
        }
        return getViewBasedDateRange(
            viewType,
            schedule,
            prev,
            format
        );
    } else {
        return tempres;
    }
}

export const getConfigDate = (viewType, schedule, currentBDate, format) => {
    let configDates = []
    for (const sch of schedule) {
        let comparisionDate = moment().format(format);
        if (viewType === compViewskeyMapper("Daily", "VALUE", "KEY")) {
            comparisionDate = currentBDate;
        } else if (viewType === compViewskeyMapper("Monthly", "VALUE", "KEY")) {
            if (sch === "lastday") {
                comparisionDate = moment(currentBDate, format).endOf("month").format(format);
            } else {
                comparisionDate = moment(currentBDate, format).set("date", sch).format(format);
            }
        }

        configDates.push(comparisionDate);
    }
    return configDates;
}

export const getHierarchy = (list, parent = { parentId: null, level: 0 }) => {
    let result = [];

    /**
     * Get every element whose parent_id attribute matches the parent's id.
     */
    const children = list.filter(item => item.parentId === parent.parentId);

    /**
     * Set the level based on the parent level for each element identified,
     * add them to the result array, then recursively sort the children.
     */
    children.forEach(child => {
        child.level = parent.level + 1;
        result = [...result, child, ...getHierarchy(list, { parentId: child.id, level: child.level })];
    });

    return result;
}

function findParentIndex(parentName, parentChildMapping) {
    for (let i = 0; i < parentChildMapping.length; i++) {
        if (parentChildMapping[i].indexName === parentName) {
            return i;
        }
    }
    return -1;
}

export const getParentMapping = (objectList, parentChildMapping) => {
    for (let i = 0; i < objectList.length; i++) {
        let currentObj = objectList[i];
        let currentObjIndex = findParentIndex(currentObj.indexName, parentChildMapping);

        while (currentObjIndex !== -1 && parentChildMapping[currentObjIndex].parent) {
            if (objectList.find(f => f.indexName === parentChildMapping[currentObjIndex].parent) === undefined) {
                currentObjIndex = findParentIndex(parentChildMapping[currentObjIndex].parent, parentChildMapping);
            } else {
                currentObjIndex = findParentIndex(parentChildMapping[currentObjIndex].parent, parentChildMapping);
                break;
            }

        }
        if (currentObjIndex !== -1) {
            let tempPId = objectList.find(f => (f.indexName === parentChildMapping[currentObjIndex].indexName)).id;
            currentObj.parentId = (tempPId === currentObj.id ? null : tempPId);
        } else {
            currentObj.parentId = null;
        }
    }
    return objectList;
}

export const getIterativeDependencies = (indexName, traverseIndexName, mapping, mappingIndexName) => {//eg: ("Hotels","children",,"indexName")
    const iterativeDependencies = [];
    for (const entry of mapping) {
        if (entry[mappingIndexName] === indexName) {
          if (entry[traverseIndexName] !== undefined) {
            if (Array.isArray(entry[traverseIndexName])) {
                for (const child of entry[traverseIndexName]) {
                  iterativeDependencies.push(child);
                  iterativeDependencies.push(...getIterativeDependencies(child, traverseIndexName, mapping, mappingIndexName));
                }
            } else {
                iterativeDependencies.push(entry[traverseIndexName]);
                iterativeDependencies.push(...getIterativeDependencies(entry[traverseIndexName], traverseIndexName, mapping, mappingIndexName));
            }
          }
        }
    } 
    return iterativeDependencies;
}

export const pageFilterColSpan = (pageFilters, pageSize) => {
    let multiModeColSpan = 0;
    let singleModeColSpan = 0;
    let m = pageFilters.filter(f => f.props.mode === 'multiple');
    let n = pageSize % 3 === 0 ? 1.5 : 1.25 //mod of 3 bcz pagefilter count is 3
    // let n = (pageFilters.length % 2 === 0 ? 1.5 : 1.2);
    if (pageFilters.length < 2) {
        singleModeColSpan = 6;
    } else {
        let tempSingleModeColSpan = pageSize / (n * m.length + (pageFilters.length - m.length));
        multiModeColSpan = Math.round(tempSingleModeColSpan * n);
        singleModeColSpan = Math.round(tempSingleModeColSpan);
    }
    
    return ({
        'singleModeColSpan': singleModeColSpan,
        'multiModeColSpan': multiModeColSpan,
    })
}